export const partners = ["asurion", "verizon", "att", "mcafee", "tmobile", "cricket", "adt", "youtubetv"];
export const lobs = ["soluto", "mobility", "care"];
